import React, {useState, useEffect}  from 'react'
import intl from 'react-intl-universal';
import '@/assets/css/vip.scss';
const VIP = () => {
    let [vipService, setVipService] = useState({})
    let [vipInfo, setVipInfo] = useState(null)
    let [vipAfter, setVipAfter] = useState(null)
    let [vipBanner, setVipBanner] = useState('')
    let [isCn] = useState(intl.getInitOptions().currentLocale === 'zh-CN')
    const initData = () => {
        const langVipService = intl.get('about').service
        langVipService.array.forEach(val => {
            val.showItem = false
        })
        const afterSale = intl.get('about').afterSale
        afterSale.forEach(val => {
            val.showItem = false
        })
        setVipBanner(intl.get('about').banner.url)
        setVipInfo(intl.get('vip'))
        setVipAfter(afterSale)
        setVipService(langVipService)
    }

    const goCenter = () => {
        window.location.href = 'https://m.bigaka.com/user-center/main.do?methodName=memberCenter&storeid=16238&salesid='
    }

    useEffect(() => {
        initData()
    },[])

    const showItem = (item, index, type = 'service') => {
        let data = {}
        if (type === 'service') {
            data = Object.assign({}, vipService)
            data.array[index].showItem = !item.showItem
            setVipService(data)
        } else if (type === 'after') {
            data = Object.assign({}, vipAfter)
            data[index].showItem = !item.showItem
            setVipAfter(data)
        }

    }
    return (
        <div className="rl">
            <div className="rl-container rl-vip flex-column">
                <section className="vip-header flex-between">
                    <img src={vipBanner} alt=""/>
                </section>
                <section className="vip-content flex-column">
                    <div className="vip-content-item">
                        <div className="vip-item-head">{vipInfo && vipInfo[0].title}</div>
                        <div className="vip-item-info">
                            {
                                vipInfo && vipInfo[0].des.map(val => {
                                  return (
                                      <p key={val}>{ val }</p>
                                  )
                                })
                            }
                        </div>
                    </div>
                    <div className="vip-content-item">
                        <div className="vip-item-head">{vipInfo && vipInfo[1].title}</div>
                        <div className="vip-item-info">
                            {
                                vipInfo && vipInfo[1].des.map(val => {
                                    return (
                                        <p key={val}>{ val }</p>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="vip-content-item">
                        <div className="vip-item-head">{intl.get('vip')[2].title}</div>
                        <div className="vip-item-info">
                            {
                                intl.get('vip')[2].des.map(val => {
                                    return (
                                        <p key={val}>{ val }</p>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="vip-content-item">
                        <div className="vip-item-head">{vipInfo && vipInfo[3].title}</div>
                        <div className="vip-item-info">
                            {
                                vipInfo && vipInfo[3].des.map(val => {
                                    return (
                                        <p key={val}>{ val }</p>
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>
                <section className="vip-btn flex-center" onClick={() => goCenter()}>
                    {vipInfo && vipInfo[4].btn1}
                </section>
                <section className="vip-content flex-column">
                    <div className="vip-content-other">
                        <div className="vip-other-head"> {vipService.title}</div>
                        {
                            vipService.array && vipService.array.map((val, index) => {
                                return (
                                    <div className="vip-other-info" key={val.title}>
                                        <div className="vip-info-head flex-between">
                                            <div>{val.title}</div>
                                            <div className="info-head-ctr" onClick={() => showItem(val, index)}>
                                                {
                                                    val.showItem ? '-' : '+'
                                                }
                                            </div>
                                        </div>
                                        {
                                            val.showItem && (<div>
                                                {
                                                    val.des.map(v => {
                                                        return (
                                                            <div className="vip-info-detail" key={v.name}>
                                                                <div className={['vip-info-item ', isCn ? ' flex-row-start' : ' flex-column-start' ]}>
                                                                    <div className="info-left">{v.name}</div>
                                                                        <div className={['info-right ',
                                                                            (v.type === 'LEATHER' && isCn) ? ' margin ' : '',
                                                                            !isCn ? ' padding-left' : ''
                                                                        ]}>
                                                                        {
                                                                            v.info.map(inf => {
                                                                                return (
                                                                                    <p key={inf}>{inf}</p>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>)
                                        }
                                    </div>
                                )
                            })
                        }

                    </div>
                </section>
                <section className="vip-content flex-column">
                    <div className="vip-content-other">
                        <div className="vip-other-head">{ vipAfter && vipAfter[2].title}</div>
                        <div className="vip-other-info">
                            <div className="vip-info-head flex-between">
                                <div>{vipAfter && vipAfter[0].title}</div>
                                <div className="info-head-ctr" onClick={() => showItem(vipAfter[0], 0, 'after')}>
                                    {
                                        vipAfter && vipAfter[0].showItem ? '-' : '+'
                                    }
                                </div>
                            </div>
                            {
                                vipAfter && vipAfter[0].showItem && (
                                    <div className="vip-info-detail">
                                        <div className="vip-info-item flex-row-start">
                                            <div className="info-right">
                                                {
                                                    vipAfter && vipAfter[0].des.map(val => {
                                                        return (
                                                            <p key={val}>{val}</p>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>                                )
                            }

                        </div>
                        <div className="vip-other-info">
                            <div className="vip-info-head flex-between">
                                <div>{vipAfter && vipAfter[1].array[0].title}</div>
                                <div className="info-head-ctr" onClick={() => showItem(vipAfter[1], 1, 'after')}>
                                    {
                                        vipAfter && vipAfter[1].showItem ? '-' : '+'
                                    }
                                </div>
                            </div>
                            {
                                vipAfter && vipAfter[1].showItem && (
                                    <div className="vip-info-detail">
                                        <div className="vip-info-item flex-row-start">
                                            <div className="info-right">
                                                <p>{vipAfter && vipAfter[1].array[0].text}: {vipAfter && vipAfter[1].array[0].des}</p>
                                                <div className="other flex-between">
                                                    <div className="other-item flex-row-start">
                                                        <div>{vipAfter && vipAfter[1].array[1].wb}:</div>
                                                        <div className="img">
                                                            <img src={vipAfter && vipAfter[1].array[1].wbImg} alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className="other-item flex-row-start">
                                                        <div>{vipAfter && vipAfter[1].array[1].wx}:</div>
                                                        <div className="img">
                                                            <img src={vipAfter && vipAfter[1].array[1].wxImg} alt=""/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                </section>
            </div>
        </div>
    )
}
export default VIP
